import React, { useState} from 'react';
import { connect } from "react-redux";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import VideoVisitToolTip from "./VideoVisitToolTip";

const browserName = Tools.browserDetection();
const isMobile = Tools.isMobile();
const isIOS = Tools.isIos();
const isAndroid =  Tools.isAndroid();
const isEdgeWebBrowser = browserName === "Edge" && !isMobile;

const heading = isEdgeWebBrowser ? "Update required" : "Browser not supported";
const edgeMessage = "Your version of Edge needs to be upgraded to proceed with your video visit.";
const upgradeIOSHeading = "Update required";
const upgradeIOSMessage = <>Your iOS needs to be upgraded to proceed with your video visit. <br />{`Go to Settings > General > Software Update.`}</>;
const message = isEdgeWebBrowser ? edgeMessage : "We recommend using MyBSWHealth video visit with";
const videoVisitNotAvailMessage = `Video visits are not available on ${browserName === "IE" ? "Internet Explorer" : "this browser"}.`;
const videoVisitMobileMessage = "You need MyBSWHealth app to proceed with your video visit.";

const androidAppUrl = "https://play.google.com/store/apps/details?id=com.baylorscottandwhite.healthsource&hl=en_US";
const iosAppUrl = "https://itunes.apple.com/us/app/mybswhealth/id1000856979?mt=8";
const androidChromeAppUrl = "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en_U";
const chromeWebUrl = "https://www.google.com/chrome/";
const edgeWebUrl = "https://www.microsoft.com/en-us/edge";

const BrowserErrorMessages = ({ ssoBaseUrl, isFromNonLogin, needIOSUpgrade}) => {
    let loggedInErrorMessage = "";
    const [linkCopied, setLinkCopied] = useState(false);  

    const copyLink = () => {
        logUI("MBHWeb.UI.NonLoggedIn.CopyLink.Clicked", new Date(), Tools.getURLPath());
        Tools.copyText(window.location.href);
        setLinkCopied(true);
    };   
    
    const downloadiOSMobileApp = () => {
        //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING APP STORE TO DOWNLOAD APP 
        if (typeof window !== 'undefined')
            window.location.href = `${ssoBaseUrl}app_download/iphone`;
        logUI('MBHWeb.UI.VideoVisit.iTunes.Redirect', new Date(), '/iTunesDownload');
    }

    const downloadAndroidMobileApp = () => {
        //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING PLAY STORE TO DOWNLOAD APP 
        if (typeof window !== 'undefined')
            window.location.href = `${ssoBaseUrl}app_download/android`;
        logUI('MBHWeb.UI.VideoVisit.GooglePlay.Redirect', new Date(), '/GooglePlayDownload');
    } 

    const getEdgeUpgradeLink = () =>
        <a href={edgeWebUrl} target="_blank" className="btn btn-primary upgrade-btn" onClick={() => logUI('MBHWeb.UI.VideoVisit.UpgradeEdge.Clicked', new Date(), Tools.getURLPath())}>UPGRADE</a>
    
    const getBrowserUpgradeLink = () => 
        isIOS ? ` Safari` : <a href={isAndroid ? androidChromeAppUrl : chromeWebUrl} target="_blank" onClick={() => logUI('MBHWeb.UI.VideoVisit.Chrome.Clicked', new Date(), Tools.getURLPath())}>{isFromNonLogin ? 'Google Chrome' : 'Chrome'}</a>
          
    if (isMobile) {
        loggedInErrorMessage = videoVisitMobileMessage;
    } else {
        loggedInErrorMessage = isEdgeWebBrowser ? edgeMessage : videoVisitNotAvailMessage;
    } 

    return (
        <React.Fragment>
            {isFromNonLogin ?
                <div className="browser-error">
                    <span className="svg-info" />
                    <h1 className="heading">{needIOSUpgrade ? upgradeIOSHeading : heading}</h1>
                    <div className="message">
                        {needIOSUpgrade
                            ? upgradeIOSMessage
                            : <>{message}
                                {!isEdgeWebBrowser && getBrowserUpgradeLink()}
                            </>
                        }
                    </div>
                    {isEdgeWebBrowser && getEdgeUpgradeLink()}
                    {!isEdgeWebBrowser &&
                        <React.Fragment>
                            <div className="copy-link-helper-text">
                                {needIOSUpgrade
                                    ? <>You may also join through your
                                        <a href={isIOS ? iosAppUrl : androidAppUrl} onClick={isIOS ? downloadiOSMobileApp : downloadAndroidMobileApp} target="_blank">MyBSWHealth Mobile App</a> or
                                        Google Chrome on Desktop.</>
                                    : <>Copy and paste the link below into {isIOS ? 'Safari' : 'Google Chrome'}</>
                                }
                            </div>
                            {!needIOSUpgrade &&
                                <div>
                                    <span className="copy-link">{window.location.href}</span>
                                    {linkCopied ?
                                        <button className="btn btn-check"><span className="icon-check" /></button>
                                        : <button className="btn btn-primary" onClick={copyLink}>Copy link</button>
                                    }
                                </div>
                            }
                            {linkCopied && <div className="link-success">Link is copied to clipboard.</div>}
                        </React.Fragment>
                    }            
                </div> :
                <div className="container-fluid body-content">
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="video-frame video-error">
                                <div className="video-frame__status">
                                    <div className="video-status">
                                        <div className="video-status__icon"><span className="icon-error" /></div>
                                        <div className="video-status__msg">{loggedInErrorMessage}</div>
                                        <div className="video-status__link">                    
                                            {isMobile ?
                                                <a className="btn btn-primary" href={isIOS ? iosAppUrl : androidAppUrl} onClick={isIOS ? downloadiOSMobileApp : downloadAndroidMobileApp} target="_blank">
                                                    DOWNLOAD THE APP
                                                </a>
                                                : <React.Fragment>
                                                    {isEdgeWebBrowser ?   
                                                        <React.Fragment>{getEdgeUpgradeLink()}</React.Fragment> :
                                                        <div>
                                                            For the best video experience, try using {getBrowserUpgradeLink()}.
                                                        </div>
                                                    } 
                                                </React.Fragment> 
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <VideoVisitToolTip />
                        </div>
                    </div>
                </div>                
            } 
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        ssoBaseUrl: state.session.serverData ? state.session.serverData.ssoBaseURL : ""
    };
};

export default connect(mapStateToProps, null)(BrowserErrorMessages);
